// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck-content{line-height:1.5;word-break:break-all}.ck-content img{max-width:100%}.ck-content h1,.ck-content h2,.ck-content h3,.ck-content h4,.ck-content h5,.ck-content h6,.ck-content p{margin-bottom:1em}.ck.ck-editor .tg-media{text-align:center}.ck.ck-editor .tg-media img{width:80%}.ck-content a[href]{color:#1890ff}", ""]);
// Exports
module.exports = exports;
